import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import Snackbar from '@material-ui/core/Snackbar';
import ErrorIcon from '@mui/icons-material/Error';

import { PureRender } from 'utils/component-helpers';

import { selectMessage, selectError, selectOpen } from './selectors';
import * as Actions from './actions';

const Notification = ({ message, error, open, actions }) => {
  const handleRequestClose = (_event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    actions.closeAction();
  };

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      open={open}
      autoHideDuration={error ? 10e3 : 2e3}
      onClose={handleRequestClose}
      ContentProps={{
        'aria-describedby': 'message-id',
      }}
      message={<span id="message-id">{message || error}</span>}
      action={[error && <ErrorIcon key="errorIcon" />]}
    />
  );
};
Notification.propTypes = {
  message: PropTypes.string,
  error: PropTypes.string,
  open: PropTypes.bool,
  actions: PropTypes.object,
};

export default connect(
  createStructuredSelector({
    message: selectMessage,
    error: selectError,
    open: selectOpen,
  }),
  (dispatch) => ({
    actions: bindActionCreators(Actions, dispatch),
  })
)(PureRender(Notification));
